module.exports = __webpack_public_path__ + "static/img/GE-OS.c775c78f.svg";